function ProductSections() {
    this.init();
}

ProductSections.prototype.init = function () {
    this.productId = window.productId;
    this.productHandle = window.productHandle;
    var sectionsToUpdate = document.querySelectorAll("[data-variant-switch-listener]");
    this.sectionsToUpdateIds = [];
    for (let i = 0; i < sectionsToUpdate.length; i++) {
        if (sectionsToUpdate[i].id) {  // Prüfen, ob das Element eine ID hat
            this.sectionsToUpdateIds.push(sectionsToUpdate[i].id);
        }
    }
    this.syncWithMainProductForm();
};

ProductSections.prototype.syncWithMainProductForm = function () {
    var self = this;
    window.FoxThemeEvents.subscribe(this.productId + '__VARIANT_CHANGE', function (variant) {
        self.currentVariant = variant.id
        self.fetchVariantPage(self.productHandle,self.currentVariant)        
    });
};

ProductSections.prototype.fetchVariantPage = function (productHandle,variantId) {
    var self = this;
    // Use AJAX to fetch the content related to the selected variant and update the collapsible section
    fetch(`/products/${productHandle}?variant=${variantId}`)
      .then(response => response.text())
      .then(html => {
        // Parse the new variant details from the returned HTML
        const parser = new DOMParser();
        self.doc = parser.parseFromString(html, 'text/html');
        self.updateSections()     
      })
      .catch(error => {
        console.error('Error fetching variant content:', error);
      });
}

ProductSections.prototype.updateSections = function () {
    var self = this;
    for (let i = 0; i < this.sectionsToUpdateIds.length; i++) {
      var id = this.sectionsToUpdateIds[i];
      var section = document.getElementById(id);
        if (section) { 
          var newSection = self.doc.getElementById(id);
          if(newSection) {
            section.innerHTML = newSection.innerHTML
          }
        }
    }
}


new ProductSections();

